<template>
  <div>
    <div class="top-label">
      <h2>{{ pageName }} characterization</h2>
    </div>
    <div class="card country-detail-card">
      <div class="card-content">
        <div class="columns">
          <div class="content column compliance-content">
            <div class="country-detail-card">
              <div class="label country-detail-card-header">
                <span class="country-name">{{ pageName }}</span>
              </div>
            </div>
            <compliance-pie-chart
              :fees="pieChartFees"
              :labels="pieChartLabel"
              :height="'500'"
              :currency="currency"
              :position="'bottom'"
            ></compliance-pie-chart>
            <div class="weight-by-fee final-break-down-weight-by-fee">
              <p>
                {{ totalWeight }} Kg /
                {{
                  totalFee
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
                {{ currency }}
              </p>
            </div>
          </div>
          <div
            class="content compliance-content column"
            v-if="data && data.length > 10"
          >
            <div
              class="columns no-margin no-padding"
              v-for="(rowIdx, k) in Math.ceil(data.length / 2)"
              :key="k"
            >
              <div
                class="columns column is-6 no-margin no-padding"
                v-for="(item, key) in data.slice(2 * (rowIdx - 1), 2 * rowIdx)"
                :key="key"
              >
                <div
                  class="column content-name is-8 final-break-down-content-name"
                >
                  <span>{{ item.name }}</span>
                  <span class="weight"
                    >{{ item.sales }} units / {{ item.weight }} Kg</span
                  >
                </div>
                <div class="column fees">
                  {{
                    item.fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}
                  {{ item.currency }}
                </div>
              </div>
            </div>
          </div>
          <div class="content compliance-content column" v-else>
            <div v-for="(item, index) in data" :key="index" class="columns">
              <div
                class="column content-name is-8 final-break-down-content-name"
              >
                <span>{{ item.name }}</span>
                <span class="weight"
                  >{{ item.sales }} units / {{ item.weight }} Kg</span
                >
              </div>
              <div class="column fees">
                {{ item.fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                {{ item.currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <final-breakdown-list
      :listViewHeaderName="pageName"
      :data="tableData"
      :header="tableHeader"
      :next="next"
      :previous="previous"
      :count="count"
      @loadData="loadFinalTableData"
    >
    </final-breakdown-list>
  </div>
</template>
<script>
import FinalBreakdownList from "./FinalBreakdownList.vue";
import CompliancePieChart from "./CompliancePieChart.vue";
export default {
  components: { CompliancePieChart, FinalBreakdownList },
  name: "FinalBreakdown",
  props: {
    contentHeaderData: [],
    contentData: []
  },
  data() {
    return {
      data: [],
      pieChartLabel: [],
      pieChartFees: [],
      totalFee: 0,
      totalWeight: 0,
      currency: " ",
      pageName: "",
      tableData: [],
      tableHeader: [],
      next: null,
      previous: null,
      count: 0
    };
  },
  watch: {
    contentData(newValue) {
      this.pieChartLabel = [];
      this.pieChartFees = [];
      Object.keys(newValue).forEach(key => {
        this.tableData = newValue["results"];
        this.tableHeader = newValue["headers"];
        this.next = newValue["next"];
        this.previous = newValue["previous"];
        this.count = newValue["count"];
        //need to add additional stream keys over here
        if (
          key == "Packaging" ||
          key == "WEEE" ||
          key == "Battery" ||
          key == "Paper (Non-Packaging)" ||
          key == "Textiles" ||
          key == "SUP (Single Use Plastic)"
        ) {
          const value = newValue[key];
          this.pageName = key;
          this.data = value;
          this.totalWeight = 0;
          this.totalFee = 0;
          value.forEach(v => {
            this.pieChartLabel.push(v.name);
            this.pieChartFees.push(v.fee);
            this.currency = v.currency;
            this.totalFee = this.totalFee + v.fee;
            this.totalWeight = this.totalWeight + v.weight;
          });
          this.$emit("keyName", key);
        }
      });
    }
  },
  mounted() {
    this.pieChartLabel = [];
    this.pieChartFees = [];
    Object.keys(this.contentData).forEach(key => {
      this.tableData = this.contentData["results"];
      this.tableHeader = this.contentData["headers"];
      this.next = this.contentData["next"];
      this.previous = this.contentData["previous"];
      this.count = this.contentData["count"];
      //need to add additional stream keys over here
      if (
        key == "Packaging" ||
        key == "WEEE" ||
        key == "Battery" ||
        key == "Paper (Non-Packaging)" ||
        key == "Textiles" ||
        key == "SUP (Single Use Plastic)"
      ) {
        const value = this.contentData[key];
        this.pageName = key;
        this.data = value;
        value.forEach(v => {
          this.pieChartLabel.push(v.name);
          this.pieChartFees.push(v.fee);
          this.currency = v.currency;
          this.totalFee = this.totalFee + v.fee;
          this.totalWeight = this.totalWeight + v.weight;
        });
        this.$emit("keyName", key);
      }
    });
  },
  methods: {
    loadFinalTableData(query) {
      this.$emit("loadFinalTableData", query);
    }
  }
};
</script>
